import { GeoDistance } from 'modules/queryBuilder/types';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { IterableDistanceUnit } from 'modules/queryBuilder/types';
import { QueryBuilderSelect } from '../Selects';
import { ConditionSingleValueInput } from '../ConditionInput';
import { FlexWrapper, GEO_LOCATION_WIDTH } from './ConditionGeoLocation.styles';
import { ConditionSingleValueGeolocationProps } from '../types';

type ConditionGeoDistanceInputProps = Omit<
  ConditionSingleValueGeolocationProps,
  'value' | 'onChange'
> & {
  value: GeoDistance | null;
  onChange: (val: GeoDistance | null) => void;
};

export const ConditionGeoDistanceInput = ({
  value,
  onChange,
  ...props
}: ConditionGeoDistanceInputProps) => {
  const { t } = useTranslation();
  const options = Object.values(IterableDistanceUnit).map((unit) => ({
    title: t(`storybook.geoLocation.${unit}`),
    value: unit,
  }));

  return (
    <FlexWrapper>
      <ConditionSingleValueInput
        type="number"
        onChange={(val) => {
          if (!val || !value) return;
          onChange({ distance: val, unit: value.unit });
        }}
        value={value?.distance ?? null}
        width={GEO_LOCATION_WIDTH}
        {...props}
      />
      <QueryBuilderSelect
        onChange={(val) => {
          if (!val || !value) return;
          onChange({ distance: value.distance, unit: val });
        }}
        options={options}
        value={value?.unit ?? null}
        {...props}
      />
    </FlexWrapper>
  );
};
